<template>
  <ResizablePage>
    <template v-slot:content="contentProps">
      <v-data-table
        :headers="headers"
        :items="persons"
        :items-per-page="-1"
        :height="contentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-footer
        :search="fastFilter"
        :item-class="rowStyle"
        :custom-filter="customFilter"
        @click:row="rowClick"
        @contextmenu:row="rowMenuClick"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ formatName(item) }}
        </template>
        <template v-slot:[`item.roles`]="{ item }">
          {{ getRoles(item) }}
        </template>
        <template v-slot:[`item.ids`]="{ item }">
          {{ getIdentifications(item) }}
        </template>
        <template v-slot:[`item.login`]="{ item }">
          {{ (item.login === null) ? "-" : item.login }}
        </template>
      </v-data-table>

      <v-menu
        v-model="contextMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
      >
        <v-list>
          <template v-for="(item, index) in contextItems">
            <v-divider class="mx-3" :key="index" v-if="item.topBorder" />
            <v-list-item v-if="item.enabled"
                         :key="index"
                         link
                         @click="rowMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>

      <!-- dialogs -->
      <CompanySelectionDialog ref="personExportDialog" v-on:selected="exportPersonSelected" />
    </template>
  </ResizablePage>
</template>

<script>
//import Vue from "vue";
import ResizablePage from "@/components/ResizablePage";
import CompanySelectionDialog from "@/components/dialogs/CompanySelectionDialog";
import utils from "@/utils";

export default {
  name: "PersonsView",
  components: { ResizablePage, CompanySelectionDialog },
  data() {
    return {
      mounted: false,
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextPerson: null,
      contextItems: [
        { name: "report-tachograph", title: this.$t("table.persons.context-menu.report-tachograph"), enabled: true },
        {
          name: "report-travel-expenses",
          title: this.$t("table.persons.context-menu.report-travel-expenses"),
          enabled: true
        },
        {
          name: "person-export",
          title: this.$t("table.persons.context-menu.person-export"),
          enabled: this.$store.state.auth.token.superuser,
          topBorder: true
        }
      ],

      headers: [
        {
          text: this.$t("table.persons.header.name"),
          align: "start",
          sortable: true,
          width: "20%",
          value: "name"
        },
        {
          text: this.$t("table.persons.header.roles"),
          align: "start",
          sortable: true,
          width: "20%",
          value: "roles"
        },
        {
          text: this.$t("table.persons.header.login"),
          align: "start",
          sortable: true,
          width: "15%",
          value: "login"
        },
        {
          text: this.$t("table.persons.header.ids"),
          align: "start",
          sortable: true,
          width: "45%",
          value: "ids"
        }
      ]
    };
  },

  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter;
    },
    persons: function() {
      if (this.$store.state.data.records === null || this.$store.state.data.module !== "person")
        return [];
      else
        return this.$store.state.data.records;
    }
  },

  methods: {
    customFilter(value, search, item) {
      let ls = search.toLowerCase();
      return (item.firstName !== null && item.firstName.toLowerCase().includes(ls))
        || (item.lastName !== null && item.lastName.toLowerCase().includes(ls))
        || (item.login !== null && item.login.toLowerCase().includes(ls))
        || (item.identifications !== null && item.identifications.map(id => id.code).join(" ").includes(ls));
    },

    formatName(person) {
      return utils.formatName(person.firstName, person.lastName);
    },

    getRoles(person) {
      return utils.personRoles(person).map((item) => this.$t("roles." + item)).join(", ");
    },

    getIdentifications(item) {
      if (item.identifications === null || item.identifications.length === 0)
        return "-";
      else
        return item.identifications.map((id) => {
          return id.identification + "@" + id.code;
        }).join(", ");
    },

    rowClick(item) {
      this.$router.push({ name: "data/person", params: { id: item.personId } });
    },

    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenu = true;
      this.contextPerson = item.item;

      event.preventDefault();
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "report-tachograph":
          this.$router.push({
            name: "report/tachograph",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "personId": this.contextPerson.personId, "periodName": "month-current" }
          });
          break;
        case "report-travel-expenses":
          this.$router.push({
            name: "report/travel-expenses",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "personId": this.contextPerson.personId, "periodName": "month-current" }
          });
          break;
        case "person-export":
          this.$refs.personExportDialog.open();
          break;
      }
    },

    rowStyle: function(item) {
      if (item.active !== true)
        return "table-row-hidden";
      else
        return "";
    },

    exportPersonSelected(company) {
      this.$store.dispatch("data/importPerson", {
        personId: this.contextPerson.personId,
        fromCompanyCode: this.$store.state.auth.company.code,
        toCompanyCode: company.code
      });
      // TODO: Pridani zobrazovani vysledku
    }
  },

  watch: {
    "$store.state.auth.company": function() {
      if (this.mounted)
        this.$store.dispatch("data/fetchRecords", { module: "person" });
    }
  },

  mounted() {
    this.mounted = true;
    this.$store.dispatch("data/fetchRecords", { module: "person" });
  },
  destroyed() {
    this.mounted = false;
  }
};
</script>

<style scoped>

</style>